export default __webpack_public_path__ + "static/RoslindaleVariable-VF[Display]-no-hints-babcfc9530f342b4753b33440664af2c.woff2";